import { useMemo } from "react";
import Image from "next/image";
import styles from "./AboutUs.module.css";

function buildImageList(prefix, count) {
  return Array.from({ length: count }, (_, index) => ({
    id: `${prefix}-${index + 1}`,
    src: `/assets/Awards/${prefix}${index + 1}.webp`,
    alt: `${prefix} ${index + 1}`,
  }));
}

export const AWARD_IMAGES = [
  { id: "awards-1", src: "/assets/Awards/Awards1.webp", alt: "World Travel Awards" },
  { id: "awards-2", src: "/assets/Awards/Awards2.webp", alt: "Air Tanzania" },
  { id: "awards-3", src: "/assets/Awards/Awards3.webp", alt: "Ethiopian Airlines" },
  { id: "awards-4", src: "/assets/Awards/Awards4.webp", alt: "Travel Excellence Award" },
  {
    id: "awards-5",
    src: encodeURI("/assets/Awards/Awards&Achievement1.webp"),
    alt: "Industry Achievement",
  },
  {
    id: "awards-6",
    src: encodeURI("/assets/Awards/Awards&Achievement2.webp"),
    alt: "Partner Recognition",
  },
  {
    id: "awards-7",
    src: encodeURI("/assets/Awards/Awards&Achievement3.webp"),
    alt: "Travel Partner Award",
  },
  {
    id: "awards-8",
    src: encodeURI("/assets/Awards/Awards&Achievement4.webp"),
    alt: "Service Excellence",
  },
];

export const PARTNER_IMAGES = buildImageList("Partner", 12);
export const FEATURED_IMAGES = buildImageList("Featured", 12);

export default function LogoMarquee({ items = [], duration = 10 }) {
  const loop = useMemo(
    () => (items.length ? [...items, ...items] : []),
    [items]
  );

  if (!items.length) return null;

  return (
    <div className={styles.marquee}>
      <div
        className={styles.marqueeTrack}
        style={{ "--marquee-duration": `${duration}s` }}
      >
        {loop.map((item, index) => (
          <div key={`${item.id}-${index}`} className={styles.marqueeTile}>
            <Image
              src={item.src}
              alt={item.alt || ""}
              width={140}
              height={56}
              className={styles.marqueeImage}
              unoptimized
            />
          </div>
        ))}
      </div>
    </div>
  );
}
